import React, { useEffect, useState } from "react";
import Navbar from "@/components/Navbar";
import { api, apiErr } from "@/lib/api";
import { toast } from "sonner";
import { Wallet as WalletIcon, ArrowDownCircle, ArrowUpCircle, TrendingUp } from "lucide-react";

export default function Wallet() {
  const [data, setData] = useState({ balance: 0, total_earned: 0, transactions: [] });

  useEffect(() => {
    api.get("/wallet").then(r => setData(r.data)).catch(e => toast.error(apiErr(e)));
  }, []);

  return (
    <div className="min-h-screen hub-cream">
      <Navbar/>
      <main className="max-w-4xl mx-auto px-6 md:px-10 py-10">
        <div className="hub-pill hub-sand text-[#0B1D3A] mb-3"><WalletIcon size={12}/> Mi cartera</div>
        <h1 className="font-serif text-5xl text-[#0B1D3A]">Tus ganancias.</h1>

        <div className="grid md:grid-cols-2 gap-4 mt-8">
          <div className="hub-card p-8 relative overflow-hidden">
            <div className="text-xs uppercase tracking-widest text-[#5C6B7D] font-display">Saldo disponible</div>
            <div className="font-serif text-6xl hub-coral mt-2">{data.balance.toFixed(2)}€</div>
            <div className="text-sm text-[#5C6B7D] mt-2">Se transfiere a tu cuenta cada lunes</div>
          </div>
          <div className="hub-card p-8">
            <div className="text-xs uppercase tracking-widest text-[#5C6B7D] font-display">Total ganado</div>
            <div className="font-serif text-6xl text-[#0B1D3A] mt-2">{data.total_earned.toFixed(2)}€</div>
            <div className="text-sm text-[#5C6B7D] mt-2 flex items-center gap-1"><TrendingUp size={12}/> Histórico total en MarinaHub</div>
          </div>
        </div>

        <h2 className="font-serif text-2xl text-[#0B1D3A] mt-10 mb-3">Movimientos</h2>
        <div className="hub-card divide-y divide-[#0B1D3A]/5">
          {data.transactions.length === 0 && <div className="p-8 text-center text-[#5C6B7D]">Aún no hay movimientos.</div>}
          {data.transactions.map((tx) => (
            <div key={tx.id} className="p-4 flex items-center gap-4" data-testid={`tx-${tx.id}`}>
              <div className={`w-10 h-10 rounded-full flex items-center justify-center ${tx.type === "escrow_release" ? "bg-emerald-100 text-emerald-700" : "bg-amber-100 text-amber-700"}`}>
                {tx.type === "escrow_release" ? <ArrowDownCircle size={18}/> : <ArrowUpCircle size={18}/>}
              </div>
              <div className="flex-1">
                <div className="font-display font-semibold text-sm">{tx.type === "escrow_release" ? "Pago recibido" : "Depósito de cliente"}</div>
                <div className="text-xs text-[#5C6B7D]">{new Date(tx.created_at).toLocaleString("es-ES")}</div>
              </div>
              <div className={`font-serif text-xl ${tx.type === "escrow_release" ? "hub-coral" : "text-[#0B1D3A]/60"}`}>+{tx.amount}€</div>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
}
